<template>
  <div>
    <vue-element-loading :active="appLoading" :is-full-screen="true" />
    <v-layout wrap justify-center>
      <v-flex xs12 sm12 md10 lg10 text-left>
        <v-layout px-2 pt-4 wrap>
          <v-flex xs12 sm12 md8 lg2 text-left class="align-content-center">
            <span style="font-family:opensansextrabold;font-size:24px;color:#70BA70;">&#9675;</span>
            <span
              style="font-family:opensansextrabold;font-size:20px;color:#060606"
            >&nbsp;Daily Essentials</span>
          </v-flex>
          <v-flex md2 text-left>
            <v-btn
              @click="changeList('Discount')"
              text
              :color="listType == 'Discount' ? '#101010' : '#AFAFAF'"
              small
              block
              :ripple="false"
              class="text-capitalize"
            >
              <span style="font-family:opensansbold;font-size:12px;">Discount Products</span>
            </v-btn>
            <v-progress-linear
              background-color="transparent"
              :value="listType == 'Discount' ? 100 : 0"
              color="#63028F"
              height="2"
            ></v-progress-linear>
          </v-flex>
          <v-flex md2 text-left>
            <v-btn
              @click="changeList('BestSeller')"
              text
              :color="listType == 'BestSeller' ? '#101010' : '#AFAFAF'"
              small
              block
              :ripple="false"
              class="text-capitalize"
            >
              <span style="font-family:opensansbold;font-size:12px;">Best Seller</span>
            </v-btn>
            <v-progress-linear
              :value="listType == 'BestSeller' ? 100 : 0"
              background-color="transparent"
              color="#63028F"
              height="2"
            ></v-progress-linear>
          </v-flex>
          <v-flex md2 text-left>
            <v-btn
              @click="changeList('NewProducts')"
              text
              :color="listType == 'NewProducts' ? '#101010' : '#AFAFAF'"
              small
              block
              :ripple="false"
              class="text-capitalize"
            >
              <span style="font-family:opensansbold;font-size:12px;">New Products</span>
            </v-btn>
            <v-progress-linear
              background-color="transparent"
              :value="listType == 'NewProducts' ? 100: 0"
              color="#63028F"
              height="2"
            ></v-progress-linear>
          </v-flex>
        </v-layout>
        <v-layout wrap>
          <v-flex pa-2 xs6 sm4 md3 lg3 v-for="(item,i) in products" :key="i">
            <v-card tile flat color="#EEEEEE">
              <v-layout py-4 wrap justify-start>
                <v-flex xs12>
                  <v-img :src="baseURL+'/u/'+item.image" height="150px" contain>
                    <template v-slot:placeholder>
                      <v-row class="fill-height ma-0" align="center" justify="center">
                        <v-progress-circular indeterminate color="#63028F"></v-progress-circular>
                      </v-row>
                    </template>
                  </v-img>
                </v-flex>
                <v-flex xs12 text-center style="height:50px">
                  <span
                    style="font-family:opensansextrabold;font-size:16px;color:#2D2D2D;"
                  >{{item.name}}</span>
                </v-flex>
                <!-- <v-flex py-2 xs12 text-center>
                  <v-btn small dark depressed :ripple="true" color="#63028F">
                    <span
                      style="font-family:opensanssemibold;font-size:12px;"
                      class="text-capitalize px-1"
                    >&nbsp;Upto 0% off</span>
                  </v-btn>
                </v-flex>-->
                <v-flex xs12 text-center class="align-content-center">
                  <span
                    style="font-family:opensansregular;font-size:12px;color:#4E4E4E;cursor:pointer;"
                    @click="$router.push('/DailyEssentials/'+listType+'/'+item._id+'/'+item.name)"
                  >Shop Now</span>
                  <span>
                    <v-icon size="15" color="#4E4E4E">mdi-chevron-right</v-icon>
                  </span>
                </v-flex>
              </v-layout>
            </v-card>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      appLoading: false,
      products: [],
      listType: "Discount",
    };
  },
  watch: {},
  beforeMount() {
    this.getData("/product/dailyessential/discount");
  },
  methods: {
    changeList(item) {
      this.listType = item;
      var url1;
      if (item == "Discount") {
        url1 = "/product/dailyessential/discount";
      } else if (item == "BestSeller") {
        url1 = "/product/dailyessential/bestseller";
      } else if (item == "NewProducts") {
        url1 = "/product/dailyessential/newproducts";
      }
      this.getData(url1);
    },
    getData(item) {
      this.appLoading = true;
      axios({
        method: "GET",
        url: item,
        params: {
          // pincode: localStorage.getItem("pincode"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.products = response.data.data;
        })
        .catch((err) => {
          this.appLoading = false;
          console.log(err);
        });
    },
  },
};
</script>